import Vue from 'vue';
import { Button, Container, Header, Aside, Main, Input, Message, MessageBox, Upload, RadioGroup, Radio, Dialog, Popconfirm, Popover, DatePicker, Image, Switch, Checkbox, Table, TableColumn } from 'element-ui';
import infiniteScroll from "vue-infinite-scroll";


Vue.use(infiniteScroll);
Vue.use(Button);
Vue.use(Container);
Vue.use(Header);
Vue.use(Aside);
Vue.use(Main);
Vue.use(Input);
Vue.use(Upload);
Vue.use(RadioGroup)
Vue.use(Radio)
Vue.use(Dialog)
Vue.use(Popconfirm)
Vue.use(Popover)
Vue.use(DatePicker)
Vue.use(Image)
Vue.use(Switch)
Vue.use(Checkbox)
Vue.use(Table)
Vue.use(TableColumn)
Vue.prototype.$message = Message
Vue.prototype.$confirm = MessageBox.confirm